<template>
    <v-data-table
            style="width: 100%;"
            :items="tests"
            hide-default-footer
            hide-default-header
            disable-pagination>
        <template v-slot:item="{ item }">
            <v-card outlined color="darken-1" elevation="0" class="mb-2">
                <v-card-actions class="ma-0 pa-0">
                    <v-icon :color="item.id == active ? 'green' : 'red'" class="ml-2 mt-2" size="15">mdi-checkbox-blank-circle</v-icon>
                    <v-card-title class="black--text ma-0 pa-0 ml-2 mt-2">{{item.name}}</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="mt-2" icon color="blue" @click="onPressEditTest(item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn class="mt-2" icon color="red" @click="onPressDeleteTest(item)" :loading="deleting[item.id]">
                        <v-icon>mdi-delete</v-icon>
                    </v-btn>
                    <v-btn class="mt-2 mr-2"
                           icon
                           :color="item.id == active ? 'green' : 'grey'"
                           @click="onPressActivate(item)"
                           :loading="activating[item.id]">
                        <v-icon v-if="item.id == active" size="30">mdi-toggle-switch</v-icon>
                        <v-icon v-else size="30">mdi-toggle-switch-off</v-icon>
                    </v-btn>
                </v-card-actions>
                <v-card-actions class="ma-0 pa-0">
                    <v-card-text class="grey--text ma-0 pa-0 ml-3 mr-3">{{item.message}}</v-card-text>
                </v-card-actions>
                <v-card-actions class="ma-0 pa-0 ml-3 mb-2 mt-2">
                    <template v-for="aud in sortByName(item)">
                        <v-card outlined elevation="0" class="mr-1" :width="aud.percent + '%'" :color="item.id == active ? aud.getColor() : 'grey'">
                            <v-card-actions class="ma-0 pa-0">
                                <v-card-text class="white--text ma-0 pa-0 ml-1 font-weight-black" style="margin-top: -12px">{{aud.name.toUpperCase()}} ({{aud.percent}}%)</v-card-text>
                            </v-card-actions>
                            <v-card-actions class="ma-0 pa-0">
                                <v-card-text class="white--text ma-0 pa-0 ml-1" style="font-size: 12px">{{getUsers(item, aud)}}</v-card-text>
                            </v-card-actions>
                            <v-card-actions class="ma-0 pa-0">
                                <v-card :color="shadeColor(item.id == active ? aud.getColor() : '#9E9E9E', -20)" width="100%" height="5px" elevation="0">
                                    <v-card-actions class="ma-0 pa-0" style="margin: 0px 1px 0px 1px!important;">
                                        <v-card color="white" :width="getUsersPercent(item, aud)" height="5px" elevation="0"></v-card>
                                    </v-card-actions>
                                </v-card>
                            </v-card-actions>
                        </v-card>
                    </template>
                </v-card-actions>
                <v-card-actions class="ma-0 pa-0 mb-0">
                    <v-chip label class="ml-3 mb-2 white--text" color="blue">{{item.users != 0 ? item.users : 'All'}} users</v-chip>
                    <v-chip outlined label class="ml-3 mb-2" color="grey">created: {{ Number(item.id)/1000000000 | formatDate }} </v-chip>
                </v-card-actions>
            </v-card>
        </template>
    </v-data-table>
</template>
<script>

import {AudienceTestStoreUtils} from "@/modules/maudiences/database/AudienceTestStoreUtils";

export default {
    name: "a-list-table",
    data: () => ({
        activating:{},
        deleting:{}
    }),
    methods:{
        getUsersPercent(test, aud){
            var data = this.getTotalAndCurrent(test, aud);
            if (data.total == 0){return"0%"}
            return (data.current/data.total * 100) + "%";
        },
        getUsers(test, aud){
            var data = this.getTotalAndCurrent(test, aud);
            return data.current + "/" + data.total + " users";
        },
        getTotalAndCurrent(test, aud){
            var total = 0;
            var current = 0;
            for (var a in test.audiences){
                var curAud = test.audiences[a];
                total += curAud.users;
                if (curAud.name == aud.name){
                    current = curAud.users;
                }
            }
            return {"total":total, "current":current}
        },
        sortByName(a){
            return a.audiences.map(e => e.copy()).sort((a, b) => a.name.localeCompare(b.name))
        },
        shadeColor(color, percent) {
            var R = parseInt(color.substring(1,3),16);
            var G = parseInt(color.substring(3,5),16);
            var B = parseInt(color.substring(5,7),16);
            R = parseInt(R * (100 + percent) / 100);
            G = parseInt(G * (100 + percent) / 100);
            B = parseInt(B * (100 + percent) / 100);
            R = (R<255)?R:255;
            G = (G<255)?G:255;
            B = (B<255)?B:255;
            var RR = ((R.toString(16).length==1)?"0"+R.toString(16):R.toString(16));
            var GG = ((G.toString(16).length==1)?"0"+G.toString(16):G.toString(16));
            var BB = ((B.toString(16).length==1)?"0"+B.toString(16):B.toString(16));
            return "#"+RR+GG+BB;
        },
        onPressActivate(test){
            if (this.active == test.id){
                this.$confirm("Are you sure turn OFF - " + test.name + "?").then(() => {
                    this.activating[test.id] = false
                    // AudienceTestStoreUtils.setABTestActive(test.id)
                    //     .then(() => {
                    //         this.activating = {}
                    //         this.$notify({title: 'Test successfully set active!', text: "", type: "succes"});
                    //     })
                    //     .catch((error) => {
                    //         this.activating = {}
                    //         this.$notify({title: 'Test set active fail!', text: error, type: "error"});
                    //     })
                }).catch(() => {})
            }else{
                this.$confirm("Are you sure turn ON - " + test.name + "?").then(() => {
                    this.activating[test.id] = true
                    AudienceTestStoreUtils.setABTestActive(test.id)
                    .then(() => {
                        this.activating = {}
                        this.$notify({title: 'Test successfully set active!', text: "", type: "succes"});
                    })
                    .catch((error) => {
                        this.activating = {}
                        this.$notify({title: 'Test set active fail!', text: error, type: "error"});
                    })
                }).catch(() => {})
            }
        },
        onPressEditTest(test){
            this.$emit('show-a-edit-test-popup', test, true)
        },
        onPressDeleteTest(test){
            this.$confirm("Are you sure?").then(() => {
                this.deleting[test.id] = true
                AudienceTestStoreUtils.deleteABTest(test.id)
                .then(() => {
                    this.deleting = {}
                    this.$notify({title: 'Test successfully deleted!', text: "", type: "succes"});
                })
                .catch((error) => {
                    this.deleting = {}
                    this.$notify({title: 'Test delete failed!', text: error, type: "error"});
                })
            }).catch(() => {})
        }
    },
    computed:{
        tests(){
            return AudienceTestStoreUtils.getABTests()
        },
        active(){
            return AudienceTestStoreUtils.getActiveTest()
        }
    }
}
</script>

<style scoped>
</style>